import React from 'react';
import style from './style.css';

const UnderReview = () => {
    return (
        <div>
            <h2 className={`${style.heading} ${style.specificity}`}>Your account is currently under review.</h2>
            <p>
                Your request will be reviewed in the next three business days. You will receive an email from us
                informing you if your request was granted.
            </p>
            <div className={style.buttonContainer}>
                <a href="https://www.shiftwellness.org">
                    <button type="button" className={`btn btn-primary ${style.backBtn}`}>
                        Back to <strong>SHIFT</strong> Wellness
                    </button>
                </a>
            </div>
        </div>
    );
};

export default UnderReview;
